/**
 * Created by feiyugao.
 * Date: 2016/12/2.
 * Content:parse txt to QQFace.
 * Usage: QQFaceTool.parse(msg);
 */

const WXFaceConfig = require('./WXFaceConfig');

const faceCode = [];
const faceHumen = [];

if(WXFaceConfig.WXFaceMap && WXFaceConfig.WXFaceMap.length){
    for(var i = 0; i < WXFaceConfig.WXFaceMap.length; i++) {
        var item = WXFaceConfig.WXFaceMap[i];
        if (typeof item.code !== 'undefined') {
            faceCode.push(item.code);
            faceHumen.push(item.alias || item.text);
        }
    }
}

const faceDict = {
    index: faceCode,
    humen: faceHumen
};

function codeToText(msg) {
    // 转换[f_xx]到汉字
    return msg ? msg.replace(/\[f_(\d*?)\]/g, function($0, $1) {
        for (let i = 0; i < faceDict.index.length; i++) {
            if (faceDict.index[i] == $1) {
                return `[${faceDict.humen[i]}]`;
            }
        }
    }) : '';
}

function textToCode(text) {
    // 将文字表情转换成[f_xx]
    for (let i = 0; i < faceHumen.length; i++) {
        const reg = `\\[${faceHumen[i]}\\]`;
        text = text.replace(new RegExp(reg, 'g'), `[f_${faceCode[i]}]`);
    }
    return text;
}

export default {
    codeToText,
    textToCode
};
